import { render, staticRenderFns } from "./PosTransitionDialog.vue?vue&type=template&id=117e3294&scoped=true&"
import script from "./PosTransitionDialog.vue?vue&type=script&lang=js&"
export * from "./PosTransitionDialog.vue?vue&type=script&lang=js&"
import style0 from "./PosTransitionDialog.vue?vue&type=style&index=0&id=117e3294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e3294",
  null
  
)

export default component.exports